// @flow
import React from 'react';
import * as RenterApp from 'styles/Home/StyledRenterApplication';
import BackButton from 'components/renter_application/BackButtonComponent';
import InputComponent from 'components/shared/InputComponent';
import * as Validations from 'validations/HomieValidations';
import _ from 'lodash';
import LocationActions from 'actions/LocationActions';
import LocationStore from 'stores/LocationStore';
import InputCodePhone from 'components/shared/InputPhoneCode';
import styled from 'styled-components';
import HomieContext from 'HomieContext';
import VerificationWhatsapp from 'components/shared/VerificationWhatsappComponent';
import NotifyConfirmation from 'actions/NotifyConfirmationActions';
import swal from '@sweetalert/with-react';

import StatusOptionPetsForm from 'components/shared/StatusOptionPetsFormComponent';
import NumberInputForm from 'components/shared/NumberInputFormComponent';
import Dog from 'AssetsRoot/images/homie_v3/dog.svg.react';
import DogWhite from 'AssetsRoot/images/homie_v3/dog_white.svg.react';
import $_ from 'jquery';
import MessageFlashComponent from 'components/shared/MessageFlashComponent';
import { hasRoles } from '../../../modules/dashboards/utils/ValidateRole';

const Divider = styled.div`
  box-sizing: border-box;
  height: 2px;
  width: 100%;
  border: 1px solid #ececec;
  margin: 0 0 20px;
`;

const ErrorMessage = styled.p`
  margin-top: 0;
  font-size: 14px;
  line-height: 17px;
  color: #ff0000;
`;

const CancelButton = styled(RenterApp.CancelAppButton)`
  top: 15px;
  right: 15px;
`;

const BackButtonContainer = styled(RenterApp.BackButtonContainer)`
  left: 15px;
  top: 15px;
`;

const Spacer = styled.div`
  padding-bottom: 20px;
`;

const WrapperWhatsappVerification = styled.div`
  padding: 15px;
  margin-bottom: 15px;
  background: #f0ecfc;
`;

const StyledForm = styled.form`
  margin-top: 25px;
`;

type PropsType = {
  homeApplication: any,
  onChange: (any, any) => void,
  onCancel: () => void,
  onPrevStep: () => void,
  sendWhatsappVerification: any
};

type State = {
  countries: Array<{ value: string, label: string }>,
  statesCountry: Array<{ value: string, label: string }>,
  generalError: boolean,
  submitted: boolean,
  pickingCountryCode: boolean,
  disabledButtonCode: boolean,
  timmerRun: boolean,
  user: {
    uid: string,
    name: string,
    last_name: string,
    second_last_name: string,
    gender: string,
    rfc: string,
    email: string,
    phone_country_code: string,
    mobile_phone: string,
    date_of_birth: string,
    country_of_birth: string,
    state_of_birth: string
  },
  home_application_income: {
    company: {
      id: string,
      name: string,
      company_business_role: string,
      business_name: string,
      rfc: string,
      legal_representative: string,
      phone: string
    }
  },
  has_pets: boolean,
  number_of_pets: number
};

export default class ProfileContentComponent extends React.Component<
  PropsType,
  State
> {
  state = {
    timmerRun: true,
    disabledButtonCode: true,
    countries: [],
    statesCountry: [],
    user: this.defaultValues.user,
    home_application_income: this.defaultValues.home_application_income,
    submitted: false,
    generalError: false,
    pickingCountryCode: false,
    has_pets: this.defaultValues.has_pets,
    number_of_pets: this.defaultValues.number_of_pets
  };

  get defaultValues(): any {
    const home_application = this.props.homeApplication;
    const user = this.props.homeApplication.user;
    const ha_income = this.props.homeApplication.home_application_income;

    return {
      user: {
        uid: _.get(user, 'id'),
        name: _.get(user, 'name') || '',
        last_name: _.get(user, 'last_name') || '',
        second_last_name: '',
        gender: 'na',
        rfc: _.get(user, 'rfc') || '',
        email: _.get(user, 'email'),
        phone_country_code: _.get(user, 'phone_country_code') || '',
        mobile_phone: _.get(user, 'mobile_phone') || '',
        date_of_birth: _.get(user, 'date_of_birth') || '',
        country_of_birth: _.get(user, 'country_of_birth') || '',
        state_of_birth: _.get(user, 'state_of_birth') || ''
      },
      home_application_income: {
        company: {
          id: _.get(ha_income, 'company.id'),
          name: _.get(ha_income, 'company.name') || '',
          company_business_role:
            _.get(ha_income, 'company.company_business_role') || '',
          business_name: _.get(ha_income, 'company.business_name') || '',
          rfc: _.get(ha_income, 'company.rfc') || '',
          legal_representative:
            _.get(ha_income, 'company.legal_representative') || '',
          phone: _.get(ha_income, 'company.phone') || ''
        }
      },
      has_pets: _.get(home_application, 'has_pets') || false,
      number_of_pets: _.get(home_application, 'number_of_pets') || 0
    };
  }

  componentWillMount() {
    LocationStore.addCountriesChangeListener(this.setCountries);
    LocationStore.addStatesChangeListener(this.setStates);
  }

  componentDidMount() {
    LocationActions.getCountries();
    const defaultCountry = this.props.homeApplication.user.country_of_birth;
    if (defaultCountry !== null) {
      LocationActions.getStatesByCountry(defaultCountry);
    }
  }

  componentWillUnmount() {
    LocationStore.removeCountriesChangeListener(this.setCountries);
    LocationStore.removeStatesChangeListener(this.setStates);
  }

  setCountries = () => {
    let rawCountries = LocationStore.getCountries();
    this.setState(() => {
      const countries = rawCountries.map(country => {
        return {
          value: country.alpha2,
          label: country.name
        };
      });
      return { countries };
    });
  };

  setStates = () => {
    const states = LocationStore.getStates();
    this.setState(() => {
      const statesCountry = states.map(state => {
        return {
          value: state,
          label: state
        };
      });
      return { statesCountry };
    });
  };

  onCountryChange = (value: string, path: string) => {
    const prevState = this.state.user.country_of_birth;
    this.onChange(value, path);
    if (prevState !== value && value !== '') {
      LocationActions.getStatesByCountry(value);
    }
  };

  submitSuccess = (values: {}) => {
    this.props.onChange(values);
  };

  onChange = (value: string, name: string) => {
    this.setState(prevState => {
      _.set(prevState, name, value);
      return prevState;
    });
  };

  handleSubmit = async (event: any): Promise<any> => {
    event.preventDefault();
    this.setState(
      {
        submitted: true
      },
      async () => {
        this.executeValidations();
        let valid = await this.isFieldsValidated();
        if (valid) {
          this.props.onChange(this.serializeState());
        } else {
          this.setState(
            {
              generalError: true
            },
            () => {
              $_('html, body, #Wrapper').animate({ scrollTop: 0 }, 500);
            }
          );
        }
      }
    );
  };

  serializeState = (): {} => {
    let userTemp = _.get(this.state, 'user');
    userTemp.mobile_phone = `${this.state.user.phone_country_code}${this.state.user.mobile_phone}`;
    let number_of_pets = _.get(this.state, 'number_of_pets');
    if (!this.state.has_pets) {
      number_of_pets = 0;
    }
    return {
      user: userTemp,
      home_application_income: _.get(this.state, 'home_application_income'),
      step: 'profile',
      has_pets: _.get(this.state, 'has_pets'),
      number_of_pets: number_of_pets
    };
  };

  executeValidations = () => {
    document.querySelectorAll('form input').forEach(el => {
      el.focus();
      el.blur();
    });
  };

  isFieldsValidated = async (): Promise<boolean> => {
    let rErrors = await this.resolveAfter();
    return rErrors === 0;
  };

  resolveAfter = async () => {
    return new Promise(resolve => {
      setTimeout(() => {
        const lengthError = document.querySelectorAll('form .error-message')
          .length;
        resolve(lengthError);
      }, 250);
    });
  };

  changeFormatDate = (date: string): string => {
    if (_.isNil(date)) {
      return '';
    }
    return date.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1');
  };

  handlePickingCountryCode = (isPicking: boolean, code?: number) => {
    this.setState(prevState => {
      _.set(prevState, 'pickingCountryCode', isPicking);
      if (!isPicking) {
        _.set(prevState, 'user.phone_country_code', code);
      }
      return prevState;
    });
  };

  handleChangeTimmer = (): void => {
    this.setState({
      timmerRun: false,
      disabledButtonCode: false
    });
  };

  renderWhatsappVerification = () => {
    if (this.context.currentUser.whatsapp_verified) {
      return null;
    }

    return (
      <WrapperWhatsappVerification>
        <VerificationWhatsapp
          sendWhatsappVerification={this.sendWhatsappVerification}
          placeholder={'Código de confirmación'}
          showButton={true}
          textButton="Aplicar"
          timmerRun={this.state.timmerRun}
          disabledButtonCode={this.state.disabledButtonCode}
          handleChangeTimmer={this.handleChangeTimmer}
          sendWhatsappCode={this.sendWhatsappCode}
        />
      </WrapperWhatsappVerification>
    );
  };

  isVerifiedWhatsapp = () => {
    let { whatsapp_verified } = this.context.currentUser;
    return !whatsapp_verified;
  };

  isAdminOrAdvisor = () => {
    const { currentUser } = this.context;
    return hasRoles(currentUser, ['admin', 'super_admin', 'agent']);
  };

  sendWhatsappCode = (): void => {
    const { currentUser } = this.context;
    if (!currentUser.whatsapp_verified) {
      const rawPhoneNumber = (currentUser.mobilePhone || '').replace(
        currentUser.phoneCountryCode,
        ''
      );
      const phoneWithCode = `${currentUser.phoneCountryCode}${rawPhoneNumber}`;
      NotifyConfirmation.sendCodeWhatsapp(
        currentUser.id,
        phoneWithCode,
        'home_application',
        () => {
          this.setState({
            timmerRun: true,
            disabledButtonCode: true
          });
        },
        error => {
          swal('¡Algo salió mal!', error, 'error');
        }
      );
    }
  };

  sendWhatsappVerification = (code: string): void => {
    NotifyConfirmation.verifyCodeWhatsapp(
      this.context.currentUser.id,
      code,
      () => {
        this.setState({
          whatsappVerificationSuccess: true
        });
      },
      error => {
        swal('¡Algo salió mal!', error.responseJSON.message, 'error');
      }
    );
  };

  closeVerificationSuccessMessage = () => {
    this.setState({ whatsappVerificationSuccess: false });
  };

  isForeigner = () => {
    const { user } = this.state;
    return user.country_of_birth !== 'MX';
  };

  render() {
    const {
      submitted,
      user,
      home_application_income,
      pickingCountryCode,
      has_pets,
      number_of_pets
    } = this.state;

    if (_.isUndefined(user) || _.isUndefined(home_application_income)) {
      return null;
    }

    const company = home_application_income.company;
    let petFriendlyShow = _.get(
      this.props.homeApplication,
      'home.petFriendlyShow'
    );

    return (
      <>
        {this.state.whatsappVerificationSuccess && (
          <MessageFlashComponent
            message="¡Listo! Hemos verificado tu número de whatsapp"
            visible
            closeMessageAction={this.closeVerificationSuccessMessage}
          />
        )}
        <RenterApp.AppTabContainer>
          <BackButtonContainer onClick={this.props.onPrevStep}>
            <BackButton text={'Aplicación'} />
          </BackButtonContainer>
          <RenterApp.AppTabForm>
            <StyledForm onSubmit={this.handleSubmit}>
              <RenterApp.Title>Verifica tus datos</RenterApp.Title>
              <InputComponent
                name="user.name"
                value={user.name}
                type="text"
                placeholder="Nombre(s)"
                onValueChange={this.onChange}
                schema={Validations.RequiredNameSchema}
              />
              <InputComponent
                name="user.last_name"
                value={user.last_name}
                type="text"
                placeholder="Apellido(s)"
                onValueChange={this.onChange}
                schema={Validations.RequiredNameSchema}
              />
              <InputComponent
                name="user.rfc"
                value={user.rfc}
                type="text"
                placeholder="RFC"
                onValueChange={this.onChange}
                schema={
                  this.isForeigner()
                    ? Validations.RFCSchema
                    : Validations.RequiredRFCSchema
                }
              />
              <RenterApp.StyledInputInstructions>
                Si eres extranjero este campo no es necesario
              </RenterApp.StyledInputInstructions>
              <RenterApp.EndSectionSpace />
              <InputComponent
                name="user.email"
                value={user.email}
                type="email"
                placeholder="E-mail"
                onValueChange={this.onChange}
                schema={Validations.RequiredEmailSchema}
              />
              <InputCodePhone
                type="text"
                placeholder={'Teléfono'}
                name="user.mobile_phone"
                value={user.mobile_phone}
                pickingCountryCode={pickingCountryCode}
                countryCode={+user.phone_country_code}
                handleCountryCodeClick={() => {
                  this.handlePickingCountryCode(true);
                }}
                handleCountryCodePicked={(el: any) => {
                  this.handlePickingCountryCode(false, +el.value);
                }}
                onValueChange={this.onChange}
                schema={Validations.PhoneNumberSchema}
              ></InputCodePhone>
              <RenterApp.Title>Acerca de la empresa</RenterApp.Title>
              <InputComponent
                name="home_application_income.company.name"
                value={company.name}
                type="text"
                placeholder="Nombre"
                onValueChange={this.onChange}
                schema={Validations.RequiredFieldSchema}
              />
              <InputComponent
                name="home_application_income.company.company_business_role"
                value={company.company_business_role}
                type="text"
                placeholder="Actividad / Giro"
                onValueChange={this.onChange}
                schema={Validations.RequiredFieldSchema}
              />
              <InputComponent
                name="home_application_income.company.business_name"
                value={company.business_name}
                type="text"
                placeholder="Razón social"
                onValueChange={this.onChange}
                schema={Validations.RequiredFieldSchema}
              />
              <InputComponent
                name="home_application_income.company.rfc"
                value={company.rfc}
                type="text"
                placeholder="RFC"
                onValueChange={this.onChange}
                schema={Validations.RequiredRFCSchema}
              />
              <InputComponent
                name="home_application_income.company.legal_representative"
                value={company.legal_representative}
                type="text"
                placeholder="Nombre del representante legal"
                onValueChange={this.onChange}
                schema={Validations.RequiredNameSchema}
              />
              <InputComponent
                name="home_application_income.company.phone"
                value={company.phone}
                type="text"
                placeholder="Teléfono"
                onValueChange={this.onChange}
                maxLength={24}
                schema={Validations.PhoneNumberWithCountryCodeSchema}
                errors={submitted}
              />
              <Divider />
              <StatusOptionPetsForm
                name={'has_pets'}
                text={'Voy a vivir con mascotas'}
                Icon={Dog}
                IconSelected={DogWhite}
                value={has_pets}
                id={'has_pets'}
                onChangeValue={this.onChange}
              />

              {has_pets && !petFriendlyShow && !_.isNil(petFriendlyShow) && (
                <div>
                  <ErrorMessage>
                    Te recordamos que este inmueble no acepta mascotas
                  </ErrorMessage>
                  <Spacer />
                </div>
              )}

              {has_pets && (
                <div>
                  <RenterApp.Title>¿Cuántas?</RenterApp.Title>
                  <NumberInputForm
                    name={'number_of_pets'}
                    minNumber={1}
                    maxNumber={20}
                    value={number_of_pets}
                    onValueChange={this.onChange}
                  />
                </div>
              )}

              <RenterApp.EndSectionSpace />
              <RenterApp.SubmitButton disabled={false} type="submit">
                Siguiente
              </RenterApp.SubmitButton>
            </StyledForm>
          </RenterApp.AppTabForm>
          <CancelButton onClick={this.props.onCancel}>
            Cancelar aplicación
          </CancelButton>
        </RenterApp.AppTabContainer>
      </>
    );
  }
}

ProfileContentComponent.contextType = HomieContext;
